import React, { useRef, useState } from 'react'
import 'react-placeholder/lib/reactPlaceholder.css'
import Link from 'next/link'

// next components
import Image from 'next/image'

// custom functions
import { useViewport } from 'utils'

// images and icons
import DefaultNftBG from 'assets/images/default-nft-bg.png'
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// styles
import styles from './index.module.scss'

import ImageWithFoster from 'components/ImageWithFoster'
import { getDisplayUserName } from 'utils/strings'

// apis
import SocialShareModal from 'components/Menu/SocialShareModal'
import CollectionCardMenuPage from 'components/Menu/CollectionCardMenuPage'
import CollectionCardMenuModal from 'components/Modal/CollectionCardMenuModal'
import useClickOutside from 'components/Menu/ClickOutsideMenu'

const CollectionCard = props => {
  const { collectionId, image, nftName, artistName, onClick, isOwn = false, unSave = null, isFavorite = false } = props
  const viewport = useViewport()
  const [showNftMenu, setShowNftMenu] = useState(false)
  const [openShareModal, setOpenShareModal] = useState(false)
  const [hover, setHover] = useState(false)
  const nftWidth = 600

  const menuRef = useRef(null)

  useClickOutside(menuRef, () => {
    if (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') {
      setShowNftMenu(false)
    }
  })

  return (
    <div className={styles.layout} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <div className={styles.container}>
        <div className={styles.containerCard}>
          <div className={styles.imageArea}>
            <Link href={`${window.origin}/collection/${collectionId}`} passHref>
              <a>
                <div className={styles.imageContent}>
                  <div className="w-full h-full">
                    {image !== null && image !== '' ? (
                      <ImageWithFoster
                        src={image}
                        width={nftWidth}
                        onClick={onClick}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <Image src={DefaultNftBG} alt="" className={styles.imageNft} onClick={() => onClick()} />
                    )}
                  </div>
                </div>
              </a>
            </Link>
          </div>

          <div className={`${styles.bottomSection}`}>
            <div className="w-full">
              <div ref={menuRef} className="relative w-full flex flex-col mt-[8px]">
                <Link href={`/collection/${collectionId}`} passHref>
                  <a>
                    <div className={styles.nftNameForHome}>{nftName}</div>
                  </a>
                </Link>
                {showNftMenu && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && (
                  <CollectionCardMenuPage
                    isOwn={isOwn}
                    shareCollection={() => {
                      setShowNftMenu(false)
                      setOpenShareModal(true)
                    }}
                    unSave={() => {
                      setShowNftMenu(false)
                      unSave()
                    }}
                    isFavorite={isFavorite}
                  />
                )}
                <div className="w-full flex items-center justify-between">
                  <div className={styles.artistName}>
                    <Link href={`/${artistName}`} passHref>
                      <a>{getDisplayUserName(artistName) || 'Ecosystem Artist'}</a>
                    </Link>
                  </div>

                  <div
                    className="w-[30px] h-[30px] flex justify-center items-center"
                    onClick={() => setShowNftMenu(!showNftMenu)}
                  >
                    <div className={showNftMenu ? styles.ellipseContainer : styles.ellipseHover}>
                      <ThreeDotIcon alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openShareModal && (
        <SocialShareModal
          open={openShareModal}
          close={() => setOpenShareModal(false)}
          vote={true}
          message={'Check out this artist on Foster Marketplace @foster_protocol #fostermarketplace'}
          url={`/collection/${collectionId}`}
        />
      )}

      {showNftMenu && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && (
        <CollectionCardMenuModal
          isOwn={isOwn}
          open={showNftMenu}
          onClose={() => setShowNftMenu(false)}
          shareCollection={() => {
            setShowNftMenu(false)
            setOpenShareModal(true)
          }}
          unSave={() => {
            setShowNftMenu(false)
            unSave()
          }}
          isFavorite={isFavorite}
        />
      )}
    </div>
  )
}

export default CollectionCard
